import { render } from "./case-contacts-list.vue?vue&type=template&id=311aaa11&scoped=true&ts=true"
import script from "./case-contacts-list.vue?vue&type=script&lang=ts"
export * from "./case-contacts-list.vue?vue&type=script&lang=ts"

import "./case-contacts-list.vue?vue&type=style&index=0&id=311aaa11&lang=scss&scoped=true"

import exportComponent from "E:\\Build\\vsts-agent-win-x64-4.268.0\\_work\\1\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311aaa11"]])

export default __exports__